import { useContext, useEffect, useMemo, useState } from "react";
import React, { useRef } from 'react';
import WebsocketContext, { WsEvents, useWebsocket } from "../../context/hooks/WebSocket";
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary } from "@mui/material";
import Context from "../../context/Context";
import blogFetch from "../../axios/config";
import toast from "react-hot-toast";
import language from '../../nls/language.json';
// import { Button } from "@mui/material";
import { WagonTableRadio } from "./components/WagonTableRadio";
import { Col, Container, Row, InputGroup, Button, Form } from "react-bootstrap";
import { WagonTableHeader } from "./components/WagonTableHeader";
import { WagonTableBody } from "./components/WagonTableBody";
import { WagonTableConfirmed } from "./components/WagonTableConfirmed";
import { WagonTableCards } from "./components/WagonTableCards";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import { DeleteForever } from "@mui/icons-material";
import './wagon.css'
import Loading from "../../components/Loading";
import { ModalDeleteWagon } from "./components/ModalDeleteWagon";
import { ConfirmModal } from "./components/ModalConfirmeWagon";

const INITIAL_VALUE = {
  isEdit: false,
  idWagon: 0
}


export const Wagon = () => {

  const [isEdit, setIsEdit] = useState(INITIAL_VALUE);
  const [active, setActive] = useState(false);
  const [firstPiece, setFirstPiece] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [searchParts, setSearchParts] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isMontandoVagao, setIsMontandoVagao] = useState(false); // NOVO
  const [movingPiece, setMovingPiece] = useState(null);
  const inputRef = useRef(null);

  //Lógica para moldes no vagão
  const [wagonMoldes, setWagonMoldes] = useState([]);

  const {
    getStatusSideBar,
    selectedCountry,
    wagon, setWagon,
    getFurnace,
    partsByFurnace,
    selectedFurnace,
    confirmedWagon,
    getConfirmedWagon,
    setConfirmedWagon,
    setSelectedWagon,
    selectedWagon,
    postWagon,
    getPartsByFurnace,
    loadingFullScreen,
    setSelectedFurnace,
    moldesEstoque,
    getMoldesEstoque,
    loading,
    setLoading
  } = useContext(Context);

  useEffect(() => {
    getFurnace()
    setSelectedFurnace(null)
    getMoldesEstoque('BR01');
  }, []);

  useEffect(() => {
    if (partsByFurnace?.length) {
      const eligible = partsByFurnace.filter(({ moldIsTrue, pecasSetor, wagonIsTrue }) =>
        moldIsTrue && !wagonIsTrue && !(pecasSetor?.pend_Key && pecasSetor?.ordem_SetAtual === pecasSetor?.pendMotOrigem_SAPSector))
      eligible.sort((a, b) => (parseFloat(b.pecasSetor?.hp) || 0) - (parseFloat(a.pecasSetor?.hp) || 0));
      setFirstPiece(eligible.length ? eligible[0] : null);
    }
  }, [partsByFurnace])

  // NOVO: desativa o loading quando o back retornar e atualizar wagon ou confirmedWagon
  useEffect(() => {
    if (isMontandoVagao) {
      setIsMontandoVagao(false);
    }
  }, [wagon, confirmedWagon]);

  const reset = () => {
    setSelectedWagon({
      tipoCombinacaoPeca: {},
      wagon: {}
    })
    setWagon([])
    setConfirmedWagon([])
    setIsEdit(INITIAL_VALUE)
    getConfirmedWagon()
  }

  function getBackgroundColor(aproveitamento) {
    switch (aproveitamento) {
      case 0:
        return "border-card-wagon-red";
      case 0.5:
        return "border-card-wagon-yellow";
      case 1:
        return "border-card-wagon-green";
      default:
        return "corHP";
    }
  };

  function getColorStatus(status) {
    switch (status) {
      case "BLOQUEADO":
        return "get-color-status-red"
      case "AGUARDANDO MOLDE":
        return "get-color-status-yellow"
      case "LIBERADO":
        return "get-color-status-green"
      default:
    }
  }

  const handleSelectWagon = (param) => {
    const item = JSON.parse(JSON.stringify(param))
    setSelectedWagon(item)
    setIsEdit({
      isEdit: true,
      idWagon: item.wagonInfo?.vagao_Key
        ? item.wagonInfo?.vagao_Key
        : item.tipoCombinacaoPeca.tipoComb_Key
    })
  }

  const handleCancelWagon = (data, isEdit) => {
    setIsEdit(INITIAL_VALUE)
    setSelectedWagon()
    clearWagonMoldes();
    const cancelWagon = data.map((item) => {
      if (item.wagonInfo?.vagao_Key === isEdit?.idWagon)
        if (item.wagonInfo?.vagao_Key && item.wagonInfo?.vagao_Key === selectedWagon.wagonInfo?.vagao_Key)
          item.wagon = selectedWagon.wagon
        else if (item.tipoCombinacaoPeca.tipoComb_Key === selectedWagon.tipoCombinacaoPeca.tipoComb_Key)
          item.wagon = selectedWagon.wagon
      return item;
    });
    selectedWagon.wagonInfo?.vagao_Key ? setConfirmedWagon(cancelWagon)
      : setWagon(cancelWagon);
  };

  const checkInArray = (data, peca) => {
    return data.wagon.some((item) => item.ordem_Serial === peca.ordem_Serial)
  }

  function handleAddPecaMolde(peca) {
    if (moldesEstoque.some((d) => peca.molde_Codigo === d.molde_Codigo)) {
      const indexToRemove = moldesEstoque.findIndex(d => peca.molde_Codigo === d.molde_Codigo);
      if (indexToRemove !== -1) {
        setWagonMoldes([...wagonMoldes, moldesEstoque[indexToRemove]])
        moldesEstoque.splice(indexToRemove, 1);
      }
      return true
    }
    else {
      toast.error('Não existem moldes disponiveis para a peça ' + peca.ordem_Serial, {
        duration: 3000
      })
      return false
    }
  }

  function clearWagonMoldes() {
    getMoldesEstoque('BR01');
    setWagonMoldes([])
  }

  const handleAddPeca = async (data, peca, status, statusWagon) => {
    if (!status || statusWagon || (peca.pend_Key && peca.ordem_SetAtual === peca.pendMotOrigem_SAPSector && peca.pend_Status !== "FINALIZADO"))
      return

    const updatedWagon = data.map((item) => {
      if (item.wagonInfo?.vagao_Key && item.wagonInfo?.vagao_Key === selectedWagon.wagonInfo?.vagao_Key && !checkInArray(item, peca)) {
        if (handleAddPecaMolde(peca)) {
          item.wagon.push(peca)
        }
      }
      else if (item.tipoCombinacaoPeca.tipoComb_Key === selectedWagon.tipoCombinacaoPeca.tipoComb_Key && !item.wagonInfo?.vagao_Key && !checkInArray(item, peca)) {
        if (handleAddPecaMolde(peca)) {
          item.wagon.push(peca)
        }
      }
      return item;
    });

    selectedWagon.wagonInfo?.vagao_Key
      ? setConfirmedWagon(updatedWagon)
      : setWagon(updatedWagon);

    setActive(true);
  };

  const handleRemovePeca = (wagonData, peca) => {
    const updatedWagon = (wagonData || []).map((item) => {
      const pieces = item.wagon || [];
      if (item.wagonInfo?.vagao_Key && item.wagonInfo?.vagao_Key === selectedWagon.wagonInfo?.vagao_Key)
        item.wagon = pieces.filter((itemWagon) => itemWagon.ordem_Serial !== peca.ordem_Serial);
      else if (item.tipoCombinacaoPeca?.tipoComb_Key === selectedWagon.tipoCombinacaoPeca?.tipoComb_Key)
        item.wagon = pieces.filter((itemWagon) => itemWagon.ordem_Serial !== peca.ordem_Serial);
      return item;
    });

    if (wagonMoldes.some((d) => peca.molde_Codigo === d.molde_Codigo)) {
      const indexToRemove = wagonMoldes.findIndex(d => peca.molde_Codigo === d.molde_Codigo);
      if (indexToRemove !== -1) {
        if (!moldesEstoque.some((d) => wagonMoldes[indexToRemove].molde_Lote === d.molde_Lote)) {
          moldesEstoque.push(wagonMoldes[indexToRemove])
        }
        const newWagonMoldes = [...wagonMoldes];
        newWagonMoldes.splice(indexToRemove, 1);
        setWagonMoldes(newWagonMoldes);
      }
    }

    selectedWagon.wagonInfo?.vagao_Key
      ? setConfirmedWagon(updatedWagon)
      : setWagon(updatedWagon);
    setActive(true);
  };

  const startMovePiece = (peca, sourceTipoCombKey) => {
    setMovingPiece({ peca, sourceTipoCombKey, mode: 'move' });
  };

  const startSwapPiece = (peca, sourceTipoCombKey) => {
    setMovingPiece({ peca, sourceTipoCombKey, mode: 'swap' });
  };

  const cancelMovePiece = () => setMovingPiece(null);

  const confirmMovePiece = (targetTipoCombKey) => {
    if (!movingPiece || movingPiece.mode !== 'move') return;
    if (targetTipoCombKey === movingPiece.sourceTipoCombKey) {
      setMovingPiece(null);
      return;
    }
    const updated = wagon.map((item) => {
      const key = item.tipoCombinacaoPeca?.tipoComb_Key;
      const pieces = item.wagon || [];
      if (key === movingPiece.sourceTipoCombKey) {
        item.wagon = pieces.filter(p => p.ordem_Serial !== movingPiece.peca.ordem_Serial);
      } else if (key === targetTipoCombKey) {
        const alreadyThere = pieces.some(p => p.ordem_Serial === movingPiece.peca.ordem_Serial);
        if (!alreadyThere) item.wagon = [...pieces, movingPiece.peca];
      }
      return item;
    });
    setWagon(updated);
    setMovingPiece(null);
    toast.success(`Peça ${movingPiece.peca.ordem_Serial} movida com sucesso`);
  };

  const confirmSwapPiece = (targetPeca, targetTipoCombKey) => {
    if (!movingPiece || movingPiece.mode !== 'swap') return;
    if (targetTipoCombKey === movingPiece.sourceTipoCombKey) {
      toast.error('Selecione uma peça de outro vagão');
      return;
    }
    if (targetPeca.ordem_Serial === movingPiece.peca.ordem_Serial) {
      setMovingPiece(null);
      return;
    }
    const updated = wagon.map((item) => {
      const key = item.tipoCombinacaoPeca?.tipoComb_Key;
      const pieces = item.wagon || [];
      if (key === movingPiece.sourceTipoCombKey) {
        item.wagon = pieces.map(p =>
          p.ordem_Serial === movingPiece.peca.ordem_Serial ? targetPeca : p
        );
      } else if (key === targetTipoCombKey) {
        item.wagon = pieces.map(p =>
          p.ordem_Serial === targetPeca.ordem_Serial ? movingPiece.peca : p
        );
      }
      return item;
    });
    setWagon(updated);
    setMovingPiece(null);
    toast.success(`Peças ${movingPiece.peca.ordem_Serial} e ${targetPeca.ordem_Serial} trocadas com sucesso`);
  };

  const filteredParts = (partsByFurnace || []).filter(
    ({ pecasSetor }) => {
      const term = searchParts.toLowerCase();
      return (
        pecasSetor?.ordem_Serial?.toString().toLowerCase().includes(term) ||
        pecasSetor?.ordem_VehDesc?.toString().toLowerCase().includes(term) ||
        pecasSetor?.ordem_VehCod?.toString().toLowerCase().includes(term)
      );
    }
  )

  // Ordem fixa dos vagões sugeridos, recalculada apenas quando o conjunto de vagões muda
  const safeWagon = wagon || [];
  const wagonKeysSignature = safeWagon
    .map(w => w?.tipoCombinacaoPeca?.tipoComb_Key)
    .sort()
    .join('|');

  const wagonOrder = useMemo(() => {
    return [...safeWagon]
      .sort((a, b) => {
        const mA = (a.wagon || []).reduce((s, i) => s + parseFloat(i.m2_Peca || 0), 0);
        const mB = (b.wagon || []).reduce((s, i) => s + parseFloat(i.m2_Peca || 0), 0);
        return mB - mA;
      })
      .map(w => w?.tipoCombinacaoPeca?.tipoComb_Key);
  }, [wagonKeysSignature]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      inputRef.current.select();
    }
  };

  const handleSearch = () => {
    setSearchParts('');
  };

  const handleClose = () => {
    setShowConfirmModal(false);
  };

  return (
    <>
      <Navbar />
      
      <Sidebar />

      <div className="selectFurnace">
        <WagonTableRadio reset={reset} />
      </div>

      <div className={`app_body ${getStatusSideBar()}`}>
        <Container fluid className="p-0 m-0">
            <Row>
              {!!selectedFurnace && (
                <>
                  <Col className="ColunaEsquerda">
                    <h2 className="title_tables my-2">
                      {language[selectedCountry.name].PainelFornos.pecasBuffer}
                    </h2>
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <InputGroup>
                          <Form.Control
                            className="w-10"
                            placeholder="Buscar Ordem Serial ou Veículo"
                            value={searchParts}
                            onChange={({ target }) => setSearchParts(target.value)}
                            onKeyDown={handleKeyDown}
                            ref={inputRef}
                          />
                          <Button className="bg-transparent text-black border border-1 border-solid border-gray-300" onClick={handleSearch}>
                            X
                          </Button>
                          <Button className="button-buscar-vagao" onClick={() => inputRef.current?.focus()}>
                            Buscar
                          </Button>
                        </InputGroup>
                      </div>
                      <Button
                        className="status-molde-button-form w-20 "
                        onClick={() => {
                          setIsMontandoVagao(true); // NOVO: ativa o loading
                          postWagon(firstPiece.pecasSetor, selectedFurnace, firstPiece.moldIsTrue, firstPiece.wagonIsTrue);
                          getMoldesEstoque('BR01');
                          clearWagonMoldes();
                        }}
                        disabled={!firstPiece}
                      >
                        {language[selectedCountry.name].PainelFornos.btnMontarVagao}
                      </Button>
                    </div>

                    <div className="tableFixHead tableFixHeadOverflow filawrap">
                      {loading ? <Loading /> : <table className="table text-center mt-4">
                        <thead>
                          {Object.entries(language[selectedCountry.name].Dashboard.pecasSetor.tableHeaderWagon)
                            .map(([key, value]) => (
                              <WagonTableHeader
                                key={value}
                                header={key}
                              />
                            ))}
                        </thead>
                        <tbody>
                          <WagonTableBody
                            data={filteredParts}
                            isEdit={isEdit}
                            handleAddPeca={handleAddPeca}
                            active={active}
                            reset={reset}
                          />
                        </tbody>
                      </table>}
                    </div>
                  </Col>

                  {/* NOVO: ColunaDireita com loading condicional */}
                  <Col className="ColunaDireita">
                    {isMontandoVagao ? (
                      <Loading />
                    ) : wagon.length <= 0 && selectedFurnace !== undefined ? (
                      <div className="">
                        <h2 className=" title_tables my-3">
                          {language[selectedCountry.name].PainelFornos.vagoesNaFila}
                        </h2>
                        <div className="tableFixHead tableFixHeadOverflow filawrap text-center">
                          {(confirmedWagon || []).filter((item) => item?.tipoCombinacaoPeca?.forno === selectedFurnace).map((item, itemKey) => (
                            <>
                              {showModal && <ModalDeleteWagon showModal={showModal} setShowModal={setShowModal} item={selectedWagon} />}
                              <Accordion
                                className={`${item.wagonInfo?.vagao_Key === selectedWagon?.wagonInfo?.vagao_Key
                                  ? "selectWagon" : ""} mb-3 border border-dark`}
                                key={`resultadoRelacionado-${itemKey}`}>
                                <AccordionSummary>
                                  <table>
                                    <thead>
                                      <th className="p-1">NOME COMBINAÇÃO</th>
                                      <th className="p-1">VAGÃO SERIAL</th>
                                      <th className="p-1">PEÇAS</th>
                                      <th className="p-1">JOGOS</th>
                                      <th className="p-1">STATUS VAGÃO</th>
                                    </thead>
                                    <tbody>
                                      <td className="p-1">{item.tipoCombinacaoPeca.comb_Nome}</td>
                                      <td className="p-1">{`${item.wagonInfo.vagao_Serial}`}</td>
                                      <td className="p-1">{item.wagon.length}</td>
                                      <td className="p-1">{`${(parseFloat(item.wagon.reduce((sum, item) => sum + item.m2_Peca, 0)) / 4.5).toFixed(3)}`}</td>
                                      <td className={`${getColorStatus(item.wagonInfo.status_Vagao)} p-1`}>
                                        {`${item.wagonInfo.status_Vagao}`}
                                      </td>
                                    </tbody>
                                  </table>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <table className="table m-0 tableFixHeadOverflow text-center">
                                    <thead>
                                      {Object.entries(language[selectedCountry.name].Dashboard.pecasSetor.tableHeaderSelectedWagon)
                                        .map(([key, value]) => (
                                          <WagonTableHeader
                                            key={value}
                                            header={key}
                                          />
                                        ))}
                                    </thead>
                                    <tbody>
                                      <WagonTableConfirmed
                                        data={item}
                                        isEdit={isEdit}
                                        handleRemovePeca={handleRemovePeca}
                                      />
                                    </tbody>
                                  </table>
                                </AccordionDetails>
                                <AccordionActions>
                                  <Button
                                    onClick={() => handleSelectWagon(item)}
                                    className="status-molde-button-form me-3 p-1 bd-highlight"
                                  >
                                    {language[selectedCountry.name].PainelFornos.btnSelecionar}
                                  </Button>
                                  <Button
                                    onClick={() => handleCancelWagon(confirmedWagon, isEdit)}
                                    disabled={isEdit.idWagon != item.wagonInfo.vagao_Key}
                                    className="p-1 bd-highlight"
                                    variant="secondary"
                                  >
                                    {language[selectedCountry.name].PainelFornos.btnCancelar}
                                  </Button>

                                  <Button
                                    onClick={() => setShowModal(true)}
                                    disabled={isEdit.idWagon != item.wagonInfo.vagao_Key}
                                    className="p-1 bd-highlight ms-3"
                                    variant="danger"
                                    color="error"
                                  >
                                    <DeleteForever />
                                  </Button>

                                  <Button
                                    onClick={() => setShowConfirmModal(true)}
                                    disabled={isEdit.idWagon != item.wagonInfo.vagao_Key
                                      || item.wagon.some(piece => piece.vagoes_Fornos_Pecas_Status_Molde === "MANUTENCAO")}
                                    className="ms-auto p-1 bd-highlight"
                                    variant="success"
                                  >
                                    {language[selectedCountry.name].PainelFornos.btnConfirmar}
                                  </Button>
                                  <ConfirmModal
                                    show={showConfirmModal}
                                    handleClose={handleClose}
                                    wagon={confirmedWagon}
                                    partsByFurnace={partsByFurnace}
                                    selectedWagon={selectedWagon}
                                    setIsEdit={setIsEdit}
                                    INITIAL_VALUE={INITIAL_VALUE}
                                    reset={reset}
                                    setShowConfirmModal={setShowConfirmModal}
                                  />
                                </AccordionActions>
                              </Accordion >
                            </>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className="d-flex justify-content-between">
                          <div className="w-25"></div>
                          <h2 className="title_tables me-2">
                            {language[selectedCountry.name].PainelFornos.vagaoSugerido}
                          </h2>
                          <button
                            className="w-25 btn "
                            color="error"
                            onClick={() => reset()}>
                            {language[selectedCountry.name].PainelFornos.btnReset}
                          </button>
                        </div>
                        {movingPiece && (
                          <div className="moving-banner">
                            <span>
                              {movingPiece.mode === 'swap'
                                ? <>Trocando peça <strong>{movingPiece.peca.ordem_Serial}</strong> — clique no ícone de trocar de outra peça em outro vagão</>
                                : <>Movendo peça <strong>{movingPiece.peca.ordem_Serial}</strong> — clique em um vagão para confirmar</>
                              }
                            </span>
                            <Button variant="secondary" size="sm" onClick={cancelMovePiece}>
                              Cancelar
                            </Button>
                          </div>
                        )}
                        <div className="tableFixHead tableFixHeadOverflow">
                          {(() => {
                            const confirmedSerials = new Set(
                              (confirmedWagon || []).flatMap(w => (w.wagon || []).map(p => p.ordem_Serial))
                            );
                            return wagonOrder
                              .map(key => safeWagon.find(w => w?.tipoCombinacaoPeca?.tipoComb_Key === key))
                              .filter(Boolean)
                              .filter(w => !(w.wagon || []).some(p => confirmedSerials.has(p.ordem_Serial)));
                          })().map((wagonCards, index) => {
                            const cardKey = wagonCards?.tipoCombinacaoPeca?.tipoComb_Key;
                            const isMoveMode = movingPiece && movingPiece.mode === 'move';
                            const isMoveSource = isMoveMode && cardKey === movingPiece.sourceTipoCombKey;
                            const isMoveTarget = isMoveMode && cardKey !== movingPiece.sourceTipoCombKey;
                            return (
                            <div className="pb-3" key={`table-${index}`}>
                              <div
                                className={`${cardKey === selectedWagon?.tipoCombinacaoPeca?.tipoComb_Key
                                  ? "selectWagon" : ""}  ${getBackgroundColor(wagonCards?.tipoCombinacaoPeca?.aproveitamento)} card ${isMoveSource ? "moving-source" : ""} ${isMoveTarget ? "moving-target-active" : ""}`}
                                onClick={isMoveTarget ? () => confirmMovePiece(cardKey) : undefined}
                              >

                                <div className="card-body p-1">

                                  <div className="d-flex justify-content-between align-items-center p0">
                                    <p className="title_tables m-0 p-0 nome-sugerido">
                                      {wagonCards.tipoCombinacaoPeca.comb_Nome}
                                    </p>
                                    <p className="title_tables m-0 p-0 forno-sugerido">
                                      {`${wagonCards.tipoCombinacaoPeca.forno}`}
                                    </p>

                                    <p className="text-bold title_tables m-0 jogo-sugerido">
                                      {`${(wagonCards.wagon.reduce((sum, item) => sum + parseFloat(item.m2_Peca || 0), 0) / 4.5).toFixed(3)} jogos`}
                                    </p>
                                  </div>

                                  <table className="table text-center m-0">
                                    <thead>
                                      {Object.entries(language[selectedCountry.name].Dashboard.pecasSetor.tableHeaderCardsWagon)
                                        .map(([key, value]) => (
                                          <WagonTableHeader
                                            key={value}
                                            header={key}
                                          />
                                        ))}
                                    </thead>
                                    <tbody className="overflow">
                                      <WagonTableCards
                                        isEdit={isEdit}
                                        data={wagonCards}
                                        handleRemovePeca={handleRemovePeca}
                                        startMovePiece={startMovePiece}
                                        startSwapPiece={startSwapPiece}
                                        confirmSwapPiece={confirmSwapPiece}
                                        movingPiece={movingPiece}
                                      />
                                    </tbody>
                                  </table>
                                  <div className="d-flex bd-highlight pt-1">
                                    <Button
                                      onClick={() => handleSelectWagon(wagonCards)}
                                      className="status-molde-button-form me-3 p-1 bd-highlight"
                                    >
                                      {language[selectedCountry.name].PainelFornos.btnSelecionar}
                                    </Button>

                                    <Button
                                      onClick={() => handleCancelWagon(wagon)}
                                      disabled={isEdit.idWagon != wagonCards?.tipoCombinacaoPeca?.tipoComb_Key}
                                      className="status-molde-button-form me-3 p-1 bd-highlight"
                                      variant="secondary"
                                    >
                                      {language[selectedCountry.name].PainelFornos.btnCancelar}
                                    </Button>

                                    <>
                                      <Button
                                        onClick={() => {
                                          setShowConfirmModal(true)
                                          handleSearch()
                                        }}
                                        disabled={isEdit.idWagon !== wagonCards?.tipoCombinacaoPeca?.tipoComb_Key}
                                        className="p-1 bd-highlight"
                                        variant="success"
                                      >
                                        {language[selectedCountry.name].PainelFornos.btnConfirmar}
                                      </Button>

                                      <ConfirmModal
                                        show={showConfirmModal}
                                        handleClose={handleClose}
                                        wagon={wagon}
                                        partsByFurnace={partsByFurnace}
                                        selectedWagon={selectedWagon}
                                        setIsEdit={setIsEdit}
                                        INITIAL_VALUE={INITIAL_VALUE}
                                        reset={reset}
                                        setShowConfirmModal={setShowConfirmModal}
                                      />
                                    </>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                          })}
                        </div>
                      </div>
                    )}
                  </Col>
                </>
              )}
            </Row>
          </Container>
      </div >
    </>
  );
}